import * as runtime from '@/api/runtime'
import {
  BatchReserveContactMailExtractRequest,
  BatchReserveContactMailExtractRequestToJSON
} from '@/api/models/batch'

/**
 * 帳票作成
 */
export class BatchReserveContactMailExtractApi extends runtime.BaseAPI {
  async return(
    request: BatchReserveContactMailExtractRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/reserve-contact-mail-extract`,
      BatchReserveContactMailExtractRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
